import type { Definition } from '@exodus/dependency-types';

import type { testnetsEnabledAtomDefinition } from './atoms.js';
import type { Testnets } from './module.js';

type Dependencies = {
  testnets: Testnets;
  testnetsEnabledAtom: ReturnType<typeof testnetsEnabledAtomDefinition.factory>;
};

const createTestnetsApi = ({ testnetsEnabledAtom, testnets }: Dependencies) => {
  const toggle = () => {
    return testnetsEnabledAtom.set((value) => {
      const enabled = !value;

      if (!enabled) {
        void testnets.disableAssets();
      }

      return enabled;
    });
  };

  return { testnets: { toggle } };
};

const testnetsApiDefinition = {
  id: 'testnetsApi',
  type: 'api',
  factory: createTestnetsApi,
  dependencies: ['testnetsEnabledAtom', 'testnets'],
} as const satisfies Definition;

export default testnetsApiDefinition;
